var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C10 20.1 10.9 21 12 21C13.1 21 14 20.1 14 19M20.999 18.999C19.079 17.079 18 14.474 18 11.758V11C18 8.376 16.312 6.151 13.966 5.336C13.984 5.227 14 5.115 14 5C14 3.895 13.104 3 12 3C10.895 3 10 3.895 10 5C10 5.115 10.016 5.227 10.034 5.336C7.687 6.151 6 8.376 6 11V11.758C6 14.474 4.921 17.079 3.001 18.999L3 19H21L20.999 18.999Z",
    stroke: "#646D7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsIcon);
export default __webpack_public_path__ + "static/media/alerts-icon.5252247a3bcb2b2f51cf5b0771c018d1.svg";
export { ForwardRef as ReactComponent };